import { Button, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { config } from "./formConfig";
import FormItem from "../../../components/FormItem";
import DownloadIcon from "@mui/icons-material/Download";

const Body = ({ uuid, control, errors, onSubmit, handleSubmit, onError }) => {
  const { t } = useTranslation();

  return (
    <Box className="add-controller__body">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "center",
        }}
      >
        <Typography className="form-section-label">{t("label:link_text")}</Typography>
        <Link
          target="_blank"
          to="https://storage.yandexcloud.net/prod-bucket-dozor-1/uploaded_files/ControlConsoleIntegration.zip"
        >
          <Button sx={{ p: 0, marginLeft: "20px" }} variant="text" endIcon={<DownloadIcon />}>
            Control Console
          </Button>
        </Link>
      </Box>

      <form
        id="add-controller"
        style={{ display: "flex", flexDirection: "column", gap: "24px" }}
        onSubmit={handleSubmit(onSubmit, onError)}
      >
        {config.map(({ name, label, input, ...rest }) => (
          <FormItem key={name} control={control} name={name} errors={errors} label={label} input={input} {...rest} />
        ))}
      </form>
      <Typography className="form-section-label">{t("label:info_text")}</Typography>
      <Typography style={{ color: "red", marginTop: "20px" }} className="form-section-label">
        {uuid}
      </Typography>
    </Box>
  );
};

export default Body;
